import React from 'react';
import PropTypes from 'prop-types';
import cn from "classnames";
import styles from '../../lib/global.css';
import {Link, withRouter} from 'react-router-dom';

/**
 * 导航栏
 * @returns {*}
 * @constructor
 */
const TitleBar = (props)=>(
    <div className={cn(styles.antCol, styles.antCol24)}>
        <div className={cn(styles.antPageHeader, styles.antPageHeaderGhost)} style={{paddingLeft: 0, paddingRight: 0}}>
            <div className={styles.antPageHeaderHeading}>
                <div className={styles.antPageHeaderHeadingLeft} onClick={() => props.history.go(-1)}>
                    {props.left ? props.left :
                        (props.showBack ? window.L("gui.modal.back") : null)
                    }
                </div>
                <div className={styles.antPageHeaderHeadingTitle}>{props.title}</div>
                <div className={styles.antPageHeaderHeadingExtra}>
                    {props.right}
                </div>
            </div>
        </div>
    </div>
);

TitleBar.protoTypes = {
    title: PropTypes.string,
    showBack: PropTypes.bool,
    left: PropTypes.node,
    right: PropTypes.node
}

TitleBar.defaultProps = {
    title: "标题",
    showBack: true,
    left: undefined,
    right: undefined
}

export default  withRouter(TitleBar);
